import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  // ### Selected date
  selectedDate: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    flexDirection: 'row',
  },
  selectedDateSplitter: {
    width: 1,
    height: 51,
    backgroundColor: '#333333',
  },
  selectedDateSplitterWrapper: {
    paddingLeft: 35,
    paddingBottom: 4,
    flex: 1,
    alignItems: 'flex-start',
  },
  selectedDateGlowWrapper: {
    height: 4,
    position: 'absolute',
    bottom: -4,
    left: -2,
    right: -2,
    borderRadius: 1,
    backgroundColor: PALETTE.primaryActive,
    shadowColor: PALETTE.primaryActive,
    shadowOpacity: 0.75,
    shadowRadius: 3,
    shadowOffset: { width: 0, height: 0 },
  },

  // ### Day
  calendarDay: {
    flex: 1,
    height: 40,
    alignItems: 'center',
  },
  calendarDayText: {
    textAlign: 'center',
    marginBottom: -4,
  },

  // ### Week
  calendarWeek: {
    flexDirection: 'row',
  },
  calendarWeekGlowWrapper: {
    position: 'absolute',
    bottom: 8,
    right: 0,
    left: 0,
    height: 2,
    flexDirection: 'row',
  },
  calendarWeekGlow: {
    backgroundColor: PALETTE.primaryActive,
    shadowColor: PALETTE.primaryActive,
    shadowOpacity: 0.75,
    shadowRadius: 3,
    shadowOffset: { width: 0, height: 0 },
  },

  // ### Month
  calendarMonth: {
    paddingTop: 21,
  },
  calendarMonthHeaderText: {
    textAlign: 'center',
    paddingBottom: 20,
  },
  calendarMonths: {
    flex: 0.5,
    borderColor:'green',
    borderWidth:1,
    paddingLeft: 25,
    paddingRight: 25,
  },
  dateContainerIE: {
    display: 'block'
  }
});
